<template>
  <div class="db-chart-card card">
    <div class="db-chart-card__header">
      <h5>{{ title }}</h5>
      <p>{{ subtitle }}</p>
    </div>

    <div v-if="hasSeries" class="db-chart-card__body">
      <apexchart :height="height" :type="type" :options="options" :series="series"></apexchart>
    </div>
    <div v-else class="db-empty">Sin datos suficientes para visualizar esta grafica.</div>
  </div>
</template>

<script>
export default {
  name: 'DashboardChartCard',
  props: {
    title: { type: String, default: '' },
    subtitle: { type: String, default: '' },
    series: { type: Array, default: () => [] },
    options: { type: Object, default: () => ({}) },
    type: { type: String, default: 'bar' },
    height: { type: [String, Number], default: 320 },
  },
  computed: {
    hasSeries() {
      return Array.isArray(this.series) && this.series.some((item) => Array.isArray(item?.data) && item.data.length);
    },
  },
};
</script>

<style scoped>
.db-chart-card {
  border-radius: 16px;
  border: 1px solid rgba(115, 102, 255, 0.2);
  box-shadow: 0 12px 28px rgba(11, 48, 64, 0.08);
  background: #fff;
  margin-bottom: 1rem;
}

.db-chart-card__header {
  padding: 1rem 1rem 0;
}

.db-chart-card__header h5 {
  margin: 0;
  font-size: 1rem;
  color: var(--theme-deafult);
}

.db-chart-card__header p {
  margin: 0.2rem 0 0;
  font-size: 12px;
  color: #5d7685;
}

.db-chart-card__body {
  padding: 0.35rem 0.7rem 0.5rem;
}

.db-empty {
  min-height: 220px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  font-size: 13px;
  color: #5d7383;
  padding: 1.25rem;
}
</style>
